import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["onClick", "onLoadingFinish", "loading", "failed"];
import { ConfirmModal } from 'foundations-components/transitional/components/ConfirmModal';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { ACTION_TYPES } from '../../contexts/UnsavedChangesContext';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function ConfirmationMessage({
  actionType
}) {
  if (actionType === ACTION_TYPES.CLOSE) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "app-governance-lib.unsavedChanges.confirmation.close.title"
    });
  }
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "app-governance-lib.unsavedChanges.confirmation.tabSwitch.title"
  });
}
function ConfirmationDescription({
  actionType
}) {
  if (actionType === ACTION_TYPES.CLOSE) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "app-governance-lib.unsavedChanges.confirmation.close.description"
    });
  }
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "app-governance-lib.unsavedChanges.confirmation.tabSwitch.description"
  });
}
function ConfirmLabel({
  actionType
}) {
  if (actionType === ACTION_TYPES.CLOSE) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "app-governance-lib.unsavedChanges.confirmation.close.confirm"
    });
  }
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "app-governance-lib.unsavedChanges.confirmation.tabSwitch.confirm"
  });
}
function RejectLabel() {
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "app-governance-lib.unsavedChanges.confirmation.cancel"
  });
}
const ConfirmLoadingButton = props => {
  const {
      onClick,
      onLoadingFinish,
      loading,
      failed
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx(LoadingButton, Object.assign({}, rest, {
    onClick: onClick,
    onLoadingFinish: onLoadingFinish,
    loading: loading,
    failed: failed,
    preventClicksOnLoading: true,
    keepResultAfterFinish: true
  }));
};
export function UnsavedChangesConfirmationDialog({
  actionType,
  onConfirm,
  onCancel,
  onClose,
  onLoadingFinish,
  loading,
  failed
}) {
  return /*#__PURE__*/_jsx(ConfirmModal, {
    message: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(ConfirmationMessage, {
        actionType: actionType
      }), /*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: onClose
      })]
    }),
    description: /*#__PURE__*/_jsx(ConfirmationDescription, {
      actionType: actionType
    }),
    confirmLabel: /*#__PURE__*/_jsx(ConfirmLabel, {
      actionType: actionType
    }),
    ConfirmButton: ConfirmLoadingButton,
    confirmButtonProps: {
      onClick: onConfirm,
      onLoadingFinish,
      loading,
      failed
    },
    rejectLabel: /*#__PURE__*/_jsx(RejectLabel, {}),
    onReject: onCancel,
    size: "auto"
  });
}